import { useContext, useEffect, useState } from "react"

import { useLocalSearchParams } from "expo-router"

import { Asset, AssetCollection, AssetSalesCharge, Index } from "wealthmode-frontend/backend"
import { Box, Heading, Spinner, Text, VStack } from "wealthmode-frontend/gluestack/ui"

import { SalesChargeEditor } from "@/components/widgets"
import { BackendContext } from "@/context"

export default function AssetSalesChargePage() {
  const backend = useContext(BackendContext)
  const { asset_id } = useLocalSearchParams<{ asset_id: string }>()
  const [asset, setAsset] = useState<Asset>()
  const [salesCharge, setSalesCharge] = useState<AssetSalesCharge>()

  useEffect(() => {
    ;(async () => {
      const data = backend.link("data").resolve() as Index
      await data.fetch({ reload: true })

      const assets = data.link("assets")?.resolve() as AssetCollection | undefined
      if (!assets) {
        return
      }

      const model = assets.model(asset_id)
      await model.fetch({ reload: true })

      const charge = model.link("sales_charge")?.resolve() as AssetSalesCharge | undefined
      if (!charge) {
        return
      }

      await charge.fetch({ reload: true })

      setAsset(model)
      setSalesCharge(charge)
    })().catch((err) => {
      console.error("Error: " + err)
      throw err
    })
  }, [backend, asset_id])

  return (
    <Box className="flex-1 min-h-0 overflow-y-auto p-4">
      {!asset || !salesCharge ? (
        <Spinner size={64} />
      ) : (
        <VStack className="gap-8 max-w-3xl shrink-0">
          <Heading size="xl">
            {asset.attributes.name} <Text className="text-sm text-foreground-secondary">{asset.attributes.symbol}</Text>
          </Heading>
          <SalesChargeEditor salesCharge={salesCharge} />
        </VStack>
      )}
    </Box>
  )
}
